// --- AYAQ Challenge Leaderboard ---
$(document).ready(function () {
  loadHtml(CHALLENGE_DATA.results);
  //loadHtml(testResults());
});

function testResults(){
      results = [];
    for (let i = 1; i <= 15; i++) {
        const name = `AYAQ-TEST-${i}`;
        const fakePoints = Math.floor(Math.random() * 100);
        const fakeCA = fakePoints * 10;
        const fakeEvo = Math.floor(Math.random() * 11) - 5; // -5 à +5
        const fakeNb = Math.floor(Math.random() * 3) + 1;
        results.push({
        [name]: {
            nb: fakeNb,
            ca: fakeCA,
            score_ventes: fakeNb * 5,
            scores_ca: Math.round(fakeCA / 10),
            points: fakePoints,
            evolution: fakeEvo
        }
        });
    }
    return results
}

function loadHtml(results, cfg) {
  cfg = cfg || window.CHALLENGE_DATA;

  var $tbody = $('.ayaq-rows');
  if ($tbody.length === 0 || !Array.isArray(results) || results.length === 0) return;

  $tbody.empty();

  // Tri par points décroissants
  var sorted = results.slice().sort(function(a, b){
    var aKey = Object.keys(a)[0], bKey = Object.keys(b)[0];
    var ap = (a[aKey].points || 0), bp = (b[bKey].points || 0);
    return bp - ap;
  });

  var n = sorted.length;

  // Tailles de zones (peuvent être 0)
  var z1Raw = toInt(cfg.zone1_number, 0);
  var z2Raw = toInt(cfg.zone2_number, 0);
  var z3Raw = toInt(cfg.zone3_number, 0);

  // Clamp dynamiques
  var z1 = Math.max(0, Math.min(n, z1Raw));
  var z2 = Math.max(0, Math.min(n - z1, z2Raw));
  var z3 = Math.max(0, Math.min(n - z1 - z2, z3Raw));
  var zL = Math.max(0, n - (z1 + z2 + z3));

  // Bornes (1-based)
  var z1Start = 1,         z1End = z1Start + z1 - 1;
  var z2Start = z1End + 1, z2End = z2Start + z2 - 1;
  var z3Start = z2End + 1, z3End = z3Start + z3 - 1;
  var zLStart = z3End + 1, zLEnd = zLStart + zL - 1;

  // Rang médian d'une zone
  function mid(s, e){ return (e >= s ? (s + Math.floor((e - s) / 2)) : null); }
  var z1Mid = z1 > 0 ? mid(z1Start, z1End) : null;
  var z2Mid = z2 > 0 ? mid(z2Start, z2End) : null;
  var z3Mid = z3 > 0 ? mid(z3Start, z3End) : null;
  var zLMid = zL > 0 ? mid(zLStart, zLEnd) : null;

  // Libellés (i18n → fallback)
  var label1 = resolveLabel(cfg.zone1_key_i18n, 'Zone 1');
  var label2 = resolveLabel(cfg.zone2_key_i18n, 'Zone 2');
  var label3 = resolveLabel(cfg.zone3_key_i18n, 'Zone 3');
  var labelL = resolveLabel(cfg.zone_last_key_i18n, 'Tous récompensés');

  // Info de zone pour un rang donné
  function zoneInfo(rank){
    if (z1 > 0 && rank >= z1Start && rank <= z1End)
      return { label: (rank === z1Mid ? label1 : ''), barClass: 'bar-green' };
    if (z2 > 0 && rank >= z2Start && rank <= z2End)
      return { label: (rank === z2Mid ? label2 : ''), barClass: 'bar-orange' };
    if (z3 > 0 && rank >= z3Start && rank <= z3End)
      return { label: (rank === z3Mid ? label3 : ''), barClass: 'bar-grey' };
    return { label: (zL > 0 && rank === zLMid ? labelL : ''), barClass: 'bar-none' };
  }

  // Rendu

  $.each(sorted, function(index, oneResult){
    var code = oneResult.code;
    var name = String(code).replace(/^AYAQ-/, '');
    var rank = oneResult.anchor_rank;
    var score  = (oneResult.score != null ? oneResult.score : 0);
    var score_ca   = (oneResult.score_ca != null ? oneResult.score_ca : 0);
    var score_sales   = (oneResult.score_sales != null ? oneResult.score_sales : 0);
    var score_addresses   = (oneResult.score_addresses != null ? oneResult.score_addresses : 0);
    var evo  = Number(oneResult.evolution != null ? oneResult.evolution : 0);

    var z = zoneInfo(rank);

    var evoHtml = '';
    if (evo !== 0) {
      var up = evo > 0;
      evoHtml = '<span class="delta ' + (up ? 'delta--up' : 'delta--down') + '">' +
                (up ? ('+'+evo) : evo) + ' ' + (up ? '▲' : '▼') + '</span>';
    }

    var $tr = $('<tr/>').html(
      '<td class="col-zone">' + escapeHtml(z.label) + '</td>' +
      '<td class="col-bar ' + z.barClass + '"></td>' +
      '<td class="col-rank">' + rank + '</td>' +
      '<td class="col-name">' + escapeHtml(name) + '</td>' +
      '<td class="col-evo">' + evoHtml + '</td>' +
      '<td class="col-points"><b>' + score + '</b></td>' +
      '<td class="col-sales">' + score_ca + '</td>' +
      '<td class="col-sales">' + score_addresses + '</td>'
    );

    $tbody.append($tr);
    
  });
}


/* ---------- helpers ---------- */
function toInt(v, def){ const n = Number(v); return Number.isFinite(n) ? Math.floor(n) : def; }

function resolveLabel(key, fallback){
  if (key && typeof window.t === 'function') {
    try { const s = window.t(key); if (s) return s; } catch(_){}
  }
  if (key && window.I18N && typeof window.I18N === 'object' && window.I18N[key]) {
    return String(window.I18N[key]);
  }
  return key || fallback || '';
}

function escapeHtml(s){
  return String(s)
    .replace(/&/g,"&amp;").replace(/</g,"&lt;")
    .replace(/>/g,"&gt;").replace(/"/g,"&quot;");
}


function fetchCode(email, callback) {
  email = (email || '').trim().toLowerCase();
  if (!email) { callback(null); return; }

  var url = `${window.CHALLENGE_DATA.webapp_url}?chllg=${window.CHALLENGE_DATA.challenge_id}&email=${encodeURIComponent(email)}`;
  const query = {
    url: url,
    method: 'GET',
    dataType: 'json'
  };
  $.ajax(query)
  .done(function(resp){
    console.log(JSON.stringify(resp));
    callback(resp && resp.code ? resp.code : null);
  })
  .fail(function(xhr){
    console.warn('fetchCode error', xhr && xhr.status, xhr && xhr.responseText);
    callback(null);
  });
}

// Évite les doublons d'attachement
$(document)
  .off('submit', '.code-form')
  .on('submit', '.code-form', function (e) {
    e.preventDefault();

    const $form   = $(this);
    const $email  = $form.find('.code-email');
    const $btn    = $form.find('.code-btn');
    const $wrap   = $form.closest('.ayaq-code-recovery');
    const $result = $wrap.find('.code-result');
    const $error  = $wrap.find('.code-error');
    const origTxt = $btn.text();

    // Anti double-clic
    if ($btn.prop('disabled')) return;

    // Réinitialisation
    $error.hide().text('');
    $result.hide();

    const email = ($email.val() || '').trim().toLowerCase();
    if (!email) { 
      $error.text('Merci de saisir votre email.').fadeIn(150); 
      return; 
    }

    // État "recherche en cours"
    $btn.prop('disabled', true).text('Recherche…');

    fetchCode(email, function (code) {
      // Fin de chargement
      $btn.prop('disabled', false).text(origTxt);
      $email.val('');

      if (code) {
        const link = 'https://ayaq.com/discount/' + encodeURIComponent(code);
        $result.find('.code-value').text(code);
        $result.find('.code-link').attr('href', link).text(link);
        $result.fadeIn(150);
      } else {
        $error
          .html(
            'Aucun code ne correspond à cette adresse mail.<br>' +
            '<span style="opacity:.8;">N’hésitez pas à nous contacter sur ' +
            '<a href="mailto:contact@ayaq.com">contact@ayaq.com</a>.</span>'
          )
          .fadeIn(200);
      }
    });
  });



// Bouton "copier le lien"
$(document).on('click', '.copy-btn', function() {
  const link = $(this).siblings('.code-link').attr('href');
  if (!link) return;

  navigator.clipboard.writeText(link).then(() => {
    $(this).addClass('copied');
    setTimeout(() => $(this).removeClass('copied'), 2000);
  });
});


function sendEmail(){
var code = $("#access_code").val();
if (!code || code == "") return;
    $.post('/cart/update.js', {
    attributes: {
        'challenge_code':challenge_code
    }
    }).done(function( data ) {
    document.location.reload();
    }).fail(function() {
    alert("erreur");
    }).always(function() {
    });
}